export enum LocalStorageKeys {
  IMPERSONATION_ID = "impersonationId",
  CSV_IMPORT_JOB_ID = "csvImportJobId",
  AUTH_TOKEN='auth_token'
}
